import { Component, OnInit, signal, type WritableSignal } from '@angular/core';
import { assistantFlags, assistantsEmptyStateContent } from '../../helpers/assistant.content';
import { RouterService } from '@shared/services/router.service';
import { isEmbed } from '@local/common-web';
import { EmbedService } from '@shared/embed.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EventsService, WindowService } from '@shared/services';
import { ExperiencesService } from 'src/app/bar/services/experiences.service';
import { Experiences } from '@local/client-contracts';
import { FlagsService } from '@shared/services/flags.service';

@UntilDestroy()
@Component({
  selector: 'assistants-empty-state',
  templateUrl: './assistants-empty-state.component.html',
  styleUrls: ['./assistants-empty-state.component.scss'],
})
export class AssistantsEmptyStateComponent implements OnInit {
  private readonly location = 'assistants_empty_state';
  readonly assistantsEmptyStateContent = assistantsEmptyStateContent;
  private isEmbed = isEmbed();
  isLauncher: boolean;
  disableAddSlackButton: boolean = false;
  buttonTooltip: string = '';
  initData: WritableSignal<boolean> = signal(true);

  constructor(
    private routerService: RouterService,
    private embedService: EmbedService,
    private hubService: HubService,
    private window: WindowService,
    private eventsService: EventsService,
    private assistantService: ExperiencesService,
    private flagsService: FlagsService
  ) {
    this.hubService.isLauncher$.pipe(untilDestroyed(this)).subscribe((l) => (this.isLauncher = l));
  }

  ngOnInit(): void {
    this.eventsService.event('assistant.empty_state', { location: { title: this.location } });

    this.checkForSpecificAssistant();
    this.initSlackBotInstallInfo();
    this.initEnableFlags();
  }

  checkForSpecificAssistant() {
    for (let index = 0; index < Experiences.ExperienceTypeArray.length; index++) {
      const assistantType = Experiences.ExperienceTypeArray[index];
      if (this.routerService.currentFullUrl.endsWith(assistantType)) {
        this.onClickApp(assistantType, false);
      }
    }
  }

  private async initSlackBotInstallInfo() {
    this.assistantService.disableCreateSlackAssistant$.pipe(untilDestroyed(this)).subscribe((val) => {
      this.disableAddSlackButton = val;
      this.buttonTooltip = 'This feature has been disabled by an admin.<br/> Please contact them to enable it for you.';
    });
  }

  private async initEnableFlags() {
    for (const assistantFlag of assistantFlags) {
      for (const element of assistantsEmptyStateContent.assistantsApps) {
        if (element.value === assistantFlag) {
          element.disabled = !(await this.assistantService.checkAssistantsFlags(assistantFlag));
        }
      }
    }
    this.initData.set(true);
  }

  openStandard() {
    const baseUrl = '/assistants';
    this.hubService.openUrl(baseUrl);
  }

  onClickApp(app: string, createNew: boolean = true) {
    app = app.toLowerCase();
    this.eventsService.event('assistant.add_to', {
      name: app ? `add_to_${app}` : 'add_assistant',
      location: { title: this.location },
    });
    if (Experiences.ExperiencesWithEditMode.includes(app)) {
      if (createNew) {
        if (Experiences.ExperiencesWithDraftMode.includes(app)) {
          this.assistantService.createDraftAssistant(app as Experiences.ExperienceType, { state: { mode: 'new' }, replaceUrl: false });
        } else {
          this.assistantService.createAssistant({ experienceType: app as Experiences.ExperienceType });
        }
      }
    } else {
      this.routerService.navigateByUrl(`admin/assistants/add-to/${app}`);
    }
  }
}
